import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import SettingsContent from '../Wrapper.vue';
import SettingsWrapper from '../SettingsWrapper.vue';
const AiAgentsIndex = () => import('./Index.vue');
const AiAgentsCreate = () => import('./Create.vue');
const AiAgentsEdit = () => import('./Edit.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ai_agents'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'ai_agents_wrapper',
          component: AiAgentsIndex,
          meta: {
            permissions: ['administrator'],
            featureFlag: FEATURE_FLAGS.AI_AGENTS,
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/ai_agents'),
      component: SettingsContent,
      props: {
        headerTitle: 'AI Agents',
        icon: 'robot',
        showBackButton: true,
      },
      children: [
        {
          path: 'new',
          name: 'ai_agents_new',
          component: AiAgentsCreate,
          meta: {
            permissions: ['administrator'],
            featureFlag: FEATURE_FLAGS.AI_AGENTS,
          },
        },
        {
          path: ':agentId/edit',
          name: 'ai_agents_edit',
          component: AiAgentsEdit,
          meta: {
            permissions: ['administrator'],
            featureFlag: FEATURE_FLAGS.AI_AGENTS,
          },
        },
      ],
    },
  ],
};
